import LegalDocument from "../legal-document";
import content from "./content";

export default function UserAgreement() {
  return (
    <LegalDocument
      content={content}
      documentTitle="Điều khoản và Điều kiện sử dụng"
      kicker="Điều khoản sử dụng"
    />
  );
}
